import { render, staticRenderFns } from "./SettingsMyProfile.vue?vue&type=template&id=7b6c2cfd&scoped=true"
import script from "./SettingsMyProfile.vue?vue&type=script&lang=js"
export * from "./SettingsMyProfile.vue?vue&type=script&lang=js"
import style0 from "./SettingsMyProfile.vue?vue&type=style&index=0&id=7b6c2cfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6c2cfd",
  null
  
)

export default component.exports